import React, { useState, useEffect } from 'react';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import { makeStyles } from '@material-ui/core/styles';
import { useAppContext } from 'hooks/useAppContext';
import { Link } from 'react-router-dom';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { IssueHistoryComment } from './IssueHistoryComment'
import { getURL } from 'utils/IssuesUtil';
const IssueHistory = ({ parents, current, reload, reloadDate }) => {

    const { selectedProject } = useAppContext(); //Getting the App Context
    const [listofnodes, setListofnodes] = useState([])

    const [url, setUrl] = useState([]);
    const useStyles = makeStyles((theme) => ({
        paper: {
            padding: '6px 16px',
        },
        secondaryTail: {
            backgroundColor: theme.palette.secondary.main,
        },
    }));
    const classes = useStyles();

    function traverse(jsonObj, temp = []) {
        let results = temp
        if (jsonObj !== null && typeof jsonObj == "object") {
            Object.entries(jsonObj).forEach(([key, value]) => {
                if (value && value.children.length > 0) {
                    results.push(value)
                    traverse(value.children, results)
                } else {
                    results.push(value)
                }
            });
        }
        else {
            // jsonObj is a number or string
        }
        return results
    }



    useEffect(() => {
        if (listofnodes.length === 0 && reload) {
            if (parents && parents.length === 0) parents.push(current)
            setListofnodes(traverse([parents[parents.length - 1]]))
            const tempURL = async () => {
                const ur = await getURL(parents[parents.length - 1].IssueId)
                setUrl(ur.data)
                //console.log(url)
                reload = false
            };
            tempURL()
        }
    }, [listofnodes, url])

    return (
        <div >
            {
                listofnodes.length > 0 ?
                    <Timeline>
                        <Typography color="textPrimary" variant="h6">
                            Issues History
                        </Typography>
                        {
                            listofnodes && listofnodes.slice(0).reverse().map(parent => {
                                const d = new Date(parent.OpenDate)
                                return (
                                    <div key={parent.IssueId}>
                                        <TimelineItem>

                                            <TimelineOppositeContent style={{ maxWidth: 200 }}>
                                                <Typography color="textSecondary">{d.toLocaleString("en-US")}</Typography>
                                            </TimelineOppositeContent>
                                            <TimelineSeparator>
                                                {current.IssueId === parent.IssueId ? <TimelineDot color="primary" variant="outlined" ><ErrorOutlineIcon color="primary" /> </TimelineDot> : <TimelineDot variant="outlined" > <ErrorOutlineIcon color="disabled" /> </TimelineDot>}
                                                <TimelineConnector />
                                            </TimelineSeparator>
                                            <TimelineContent>
                                                <Paper elevation={3} className={classes.paper}>{ }
                                                    <Link
                                                        to={{ pathname: `/projects/${selectedProject}/Issues/${parent.IssueId}`, state: { issue: parent } }}
                                                        style={{ textDecoration: 'none' }}
                                                        tooltip="launch"
                                                    >

                                                        <Typography color="textPrimary">
                                                            {parent.IssueNumber}
                                                        </Typography>
                                                        <Typography color="textSecondary">
                                                            {parent.IssueProcStatus.Description}
                                                        </Typography>
                                                        {parent.IssueDescription}

                                                        <Typography color="textSecondary">Edited by: {parent.MadeBy}</Typography>



                                                    </Link>

                                                    <>
                                                        {url && url.map(station => (
                                                            parent.IssueId == station.id &&
                                                            <div><a href={station.url} target="_blank">{station.friendlyFileName}</a></div>
                                                        ))}
                                                    </>
                                                </Paper>
                                                <IssueHistoryComment issue={parent} key={reloadDate} attachments={url} />


                                            </TimelineContent>

                                        </TimelineItem></div>

                                )
                            })
                        }
                    </Timeline> : <div></div>
            }
        </div >
    );
}

export { IssueHistory };